import React from 'react';
// COMPONENTS
// ANT
import Button from 'antd/lib/button';

const styles = {
  createContractBtn: {
    textAlign: 'center',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
};

const CreateContractButton = ({
  createInvoices, loading, onCreate, renderBackButton,
}) => (
  <div style={styles.createContractBtn}>
    <Button
      loading={loading}
      disabled={loading}
      type="primary"
      size="large"
      className="contract-flow-btn"
      onClick={() => onCreate()}
    >
      {createInvoices ? 'SEND INVOICES NOW & CREATE CONTRACT' : 'CREATE CONTRACT'}
    </Button>
    <div style={{ fontSize: 13, marginTop: 25 }}>
      <p>
          By creating a contract, you accept our <a href="#">Terms of Use</a>.
      </p>
    </div>
    <div style={{ marginTop: 15 }}>{renderBackButton()}</div>
  </div>
);
export default CreateContractButton;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/CreateContractButton/index.js